export default __webpack_public_path__ + "static/media/cfd.b6b930b7.jpg";